var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"taxe-emission-list-page page-layout"},[_c('PageHeader',{attrs:{"title":"Histoire de taxe sur vehicule société (émissions de CO₂)","has-back":true},on:{"back":_vm.goBack}}),_c('sortable-list',{attrs:{"items":_vm.data,"parameters":_vm.listParameters}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }